export default __webpack_public_path__ + "static/og-img-1.5M-eden-reforestation-projects-3dee64634658015b6abfb1c491eca842.png";